export const GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_ACTION = 'GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_ACTION';
export const GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_SUCCESS = 'GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_SUCCESS';
export const GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_FAIL = 'GET_TIPI_GIUSTIFICATIVI_BY_TIPO_CORSO_FAIL';



export const ADD_GIUSTIFICATIVO_END = 'ADD_GIUSTIFICATIVO_END';
export const ADD_GIUSTIFICATIVO_ACTION = 'ADD_GIUSTIFICATIVO_ACTION';




/*export const ADD_GIUSTIFICATIVO_SUCCESS = 'ADD_GIUSTIFICATIVO_SUCCESS';
export const ADD_GIUSTIFICATIVO_FAIL = 'ADD_GIUSTIFICATIVO_FAIL';*/

export const INIT_TIPI_GIUSTIFICATIVI = 'INIT_TIPI_GIUSTIFICATIVI';

export const GET_ALL_TIPI_GIUSTIFICATIVI_SUCCESS = 'GET_ALL_TIPI_GIUSTIFICATIVI_SUCCESS';
export const GET_ALL_TIPI_GIUSTIFICATIVI_FAIL = 'GET_ALL_TIPI_GIUSTIFICATIVI_FAIL';

export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const INSERT_TIPO_GIUSTIFICATIVO_SUCCESS = 'INSERT_TIPO_GIUSTIFICATIVO_SUCCESS';
export const INIT_UPDATE_FIELDS = 'INIT_UPDATE_FIELDS';

export const DELETE_GIUSTIFICATIVO_ACTION = 'DELETE_GIUSTIFICATIVO_ACTION';
export const DELETE_GIUSTIFICATIVO_SUCCESS = 'DELETE_GIUSTIFICATIVO_SUCCESS';
export const DELETE_GIUSTIFICATIVO_FAIL = 'DELETE_GIUSTIFICATIVO_FAIL';

export const INIT_REQUEST_GIUSTIFICATIVI = 'INIT_REQUEST_GIUSTIFICATIVI';
